// Блок «Прогрев» - общий для Telegram и MAX.
//
// Свежий номер, который сразу начинает диалоги с незнакомыми людьми, мессенджеры
// ограничивают: именно так мы потеряли отправку на живом номере MAX 03.09.2026. Поэтому
// первые сутки после привязки помощник не пишет гостю первым.
//
// Важное правило, которое здесь же и объясняется человеку: на ВХОДЯЩИЕ отвечаем всегда.
// Прогрев ограничивает нашу инициативу, а не ответ гостю - молчание в ответ на прямой
// вопрос бьёт по клиенту УК, а не по мессенджеру.

import { ThermometerIcon } from '@phosphor-icons/react';
import { StatusChip, type Tone } from '@smena/ui';

export type WarmupState = 'cold' | 'warming' | 'warm';

const LABEL: Record<WarmupState, string> = {
  cold: 'холодный',
  warming: 'прогревается',
  warm: 'прогрет',
};

const TONE: Record<WarmupState, Tone> = {
  cold: 'amber',
  warming: 'accent',
  warm: 'green',
};

const HINT: Record<WarmupState, string> = {
  cold:
    'Первые сутки после привязки помощник не пишет гостю первым: свежий номер, который сразу ' +
    'начинает диалоги с незнакомыми людьми, мессенджер ограничивает. На входящие отвечаем всё ' +
    'это время без ограничений - если гость написал, ответ уйдёт.',
  warming:
    'Вторые и третьи сутки: помощник уже может написать гостю первым по номеру из брони, но таких ' +
    'сообщений в день немного. На входящие по-прежнему отвечаем всегда.',
  warm:
    'Прошло больше трёх суток - работают полные лимиты на нашу инициативу. На входящие отвечаем ' +
    'без ограничений, как и раньше.',
};

export function WarmupBlock({ state }: { state: WarmupState }) {
  return (
    <div className="rounded-md border border-line bg-panel px-3 py-2">
      <div className="flex items-center gap-2">
        <ThermometerIcon weight="bold" className="size-3.5 text-muted" />
        <span className="text-xs font-semibold">Прогрев</span>
        <StatusChip tone={TONE[state]}>{LABEL[state]}</StatusChip>
      </div>
      <p className="mt-1.5 text-xs text-muted">{HINT[state]}</p>
    </div>
  );
}
